import { render, staticRenderFns } from "./ArticleCreatePopup.vue?vue&type=template&id=0cc853ce"
import script from "./ArticleCreatePopup.vue?vue&type=script&lang=ts"
export * from "./ArticleCreatePopup.vue?vue&type=script&lang=ts"
import style0 from "./ArticleCreatePopup.vue?vue&type=style&index=0&id=0cc853ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports